import { InputHTMLAttributes, ReactNode } from 'react';

const classPrefix = `v-upload-list`;

type UploadTriggerProps = {
  disabled?: boolean;
  capture?: InputHTMLAttributes<unknown>['capture'];
  accept?: string;
  multiple?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  uploadTriggerDesc?: string;
  children?: ReactNode;
};

export const UploadTrigger = (props: UploadTriggerProps) => {
  return (
    <div className={`${classPrefix}-operate`}>
      <div className={`${classPrefix}-operate-content`}>
        {props.children ? props.children : <span className={`${classPrefix}-button`}></span>}
        {!props.disabled && (
          <input
            capture={props.capture}
            accept={props.accept}
            multiple={props.multiple}
            type="file"
            className={`${classPrefix}-input`}
            onChange={props.onChange}
          />
        )}
      </div>
      {props.uploadTriggerDesc ? (
        <div className={`${classPrefix}-image-name`}>{props.uploadTriggerDesc}</div>
      ) : null}
    </div>
  );
};
